import React from "react";
import { useDispatch } from "react-redux";

import { getContractor as onGetContractor } from "slices/thunks";
import ManageRecordsLink from "Components/Common/RecordManager/ManageRecordsLink";
import { RecordKindConfig } from "Components/Common/RecordManager/types";

/** The record manager's Edit link for a section of the contractor profile. */
const ContractorRecordsLink = ({
  contractor,
  config,
}: {
  contractor: any;
  config: RecordKindConfig;
}) => {
  const dispatch: any = useDispatch();
  return (
    <ManageRecordsLink
      owner={contractor}
      ownerName={contractor?.contractorName}
      config={config}
      refresh={() => dispatch(onGetContractor({ id: contractor?.id }))}
    />
  );
};

export default ContractorRecordsLink;
